module.exports = __webpack_public_path__ + "img/instagram.8290266a.png";